"use strict";

var _interopRequireDefault = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/web.dom.iterable");

var _echarts = _interopRequireDefault(require("echarts"));

var _resize = _interopRequireDefault(require("./mixins/resize"));

//
//
//
//
// require('echarts/theme/macarons') // echarts theme
var _default2 = {
  mixins: [_resize.default],
  props: {
    className: {
      type: String,
      default: "chart"
    },
    width: {
      type: String,
      default: "100%"
    },
    height: {
      type: String,
      default: "700px"
    },
    values: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    placeholder: {
      type: String,
      default: ""
    }
  },
  data: function data() {
    return {
      chart: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.initChart();
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.chart) {
      return;
    }

    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart: function initChart() {
      this.chart = _echarts.default.init(this.$el, "macarons");
      this.chart.setOption({
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} USD ({d}%)"
        },
        // legend: {
        //   left: "center",
        //   bottom: "10",
        //   data: ["Industries", "Technology", "Forex", "Gold", "Forecasts"],
        //   data: this.labels,
        // },
        // calculable: true,
        series: [{
          name: this.placeholder,
          type: "pie",
          radius: "60%",
          color: ['#2ec7c9', '#b6a2de', '#5ab1ef', '#ffb980', '#d87a80', '#8d98b3', '#705F00', '#97b552', '#95706d', '#dc69aa', '#07a2a4', '#9a7fd1', '#588dd5', '#f5994e', '#c05050', '#59678c', '#c9ab00', '#7eb00a', '#6f5553', '#c14089'],
          // center: ["50%", "50%"],
          avoidLabelOverlap: true,
          data: this.values,
          animationEasing: "cubicInOut",
          // animationDuration: 1000,
          width: this.width,
          height: this.height,
          // top: 100,
          // bottom:400,
          itemStyle: {
            borderColor: "#fff",
            borderWidth: 1
          },
          label: {
            position: 'outside',
            backgroundColor: 'transparent',
            // bleedMargin: 50,
            alignTo: "edge",
            formatter: " {b}\n{c}",
            lineHeight: 15,
            edgeDistance: 0,
            // padding:[20,0,0,0],
            // height:56,
            fontSize: 13,
            //  margin:100,
            // verticalAlign:'middle',
            rich: {
              b: {
                color: 'green'
              }
            }
          },
          labelLine: {
            length: 20,
            length2: 25,
            maxSurfaceAngle: 80
          }
        }]
      });
    }
  }
};
exports.default = _default2;